import { oz } from '@weft/utils';
import { NewFixedVariantChargeSchema } from '../fixed-variant-charge';
import { NewUsageVariantChargeSchema } from '../usage-variant-charge';

export const NewVariantChargeSchema = oz.union([NewUsageVariantChargeSchema, NewFixedVariantChargeSchema]);

export type NewVariantCharge = oz.infer<typeof NewVariantChargeSchema>;